import React, { useMemo, useState } from 'react'
import { SelfRegisterHeroImage } from './components/self-register-hero-image'
import { useApFormSelfRegister } from '../../api-new/state/content'
import { useLoad } from '../../shared/hooks/load'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { SelfRegisterForm } from './components/self-register-form'
import { SelfRegisterResult } from './components/self-register-result'
import { Footer } from '../../page/component/footer'
import { AlertErrorMessage } from '../../shared/alert/alert-error'

export const SelfRegister = () => {
  const { identifier } = useParams()

  const [result, updateResult] = useState(null)
  const [error, updateError] = useState(null)

  const apFormSelfRegister = useApFormSelfRegister()

  useLoad(() => apFormSelfRegister.get(`${identifier}/init`), [])

  const handleSubmit = async data => {
    try {
      const result = await apFormSelfRegister.postArg('/register', data)
      updateResult(result)
    } catch (e) {
      // The body (AlertErrorMessage shows its message and its reference); a
      // failure with none (network) gets a sentence of its own.
      updateError(e && e.data && typeof e.data === 'object' ? e.data : { message: "We couldn't sign you up. Try again." })
    }
  }

  const handleDismiss = () => {
    apFormSelfRegister.get(`${identifier}/init`)
    updateResult(null)
    updateError(null)
  }

  let backgroundColor = useMemo(() => apFormSelfRegister.form.colorBackground || 'white', [apFormSelfRegister.form])

  return (
    <div className="d-flex flex-column h-100 p-1" style={{ backgroundColor: backgroundColor }}>
      <div className="flex-fill overflow-y-scroll">
        <div className="container h-100">
          <AlertErrorMessage error={error} />
          <SelfRegisterHeroImage identifier={apFormSelfRegister.form.identifier} />

          {result
            ? <SelfRegisterResult apFormSelfRegister={apFormSelfRegister} onDismiss={handleDismiss} />
            : <SelfRegisterForm apFormSelfRegister={apFormSelfRegister} onSubmit={handleSubmit} />}
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  )
}
